import React from "react";

export default function Service() {
 return (
  <section id="services" className="services">
   <h2 className="service-title">Our Services</h2>
   <div className="service-item">
    <h3>Recruitment</h3>
    <p>We help you find the right talent for your organization.</p>
   </div>
   <div className="service-item">
    <h3>Training</h3>
    <p>We provide training programs to enhance employee skills.</p>
   </div>
   <div className="service-item">
    <h3>Consulting</h3>
    <p>Our experts offer consulting services to improve HR processes.</p>
   </div>
  </section>
 );
}